export default function Footer() {
    return (
        <footer className="footer footer-static footer-light navbar-border">
            <p className="clearfix blue-grey lighten-2 text-sm-center mb-0 px-2">
                <span className="float-md-left d-block d-md-inline-block">
                    Copyright &copy; 2025{' '}
                    <a
                        className="text-bold-800 grey darken-2"
                        href="/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        MPA
                    </a>
                </span>
                <span className="float-md-right d-none d-lg-block">

                </span>
            </p>
        </footer>
    )
}